import url from "@/prod.js";

const GA4_MEASUREMENT_ID = "G-K51T6T1GCD";

export function pushAnalyticsUserId(userId) {
  if (url.appStatus !== "production" || userId == null || userId === "") {
    return;
  }

  const normalizedUserId = String(userId);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "user_id_set",
    user_id: normalizedUserId,
  });

  if (typeof window.gtag === "function") {
    window.gtag("config", GA4_MEASUREMENT_ID, {
      user_id: normalizedUserId,
    });
  }
}
